import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import style from "./Login.module.css";
import DecodeToken from "./DecodeToken";
import { IP } from "../../utils/Host";
import { getCurrentBuildHash } from "actions/getCurrentBuildHash";

import { useSocket } from "../../context/SocketContext";
import { AppContext } from "context/AppContext";
import { TechnologyContext } from "context/TechnologyContext";

import iconLogo from "../../assets/logo_biale.svg";
import iconAdd from "assets/history.svg";

export default function Login() {
  const [logowanie, setLogowanie] = useState(true);
  const [input, setInput] = useState({ login: "", haslo: "" });
  const navigate = useNavigate();

  const contextApp = useContext(AppContext);
  const techContext = useContext(TechnologyContext);
  const { updateAuthStatus } = useSocket();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLogowanie(false);

    try {
      const hash = getCurrentBuildHash();
      
      // ZAMIAST GET (z hasłem w URL) ZALECANY JEST POST!
      // Jeśli na backendzie nadal masz GET, dostosuj URL.
      const res = await axios.get(`${IP}users/${encodeURIComponent(input.login)}/${encodeURIComponent(input.haslo)}/${hash}`);

      const token = res.data?.[0];
      const ver = res.data?.[1]?.[0];

      if (token && token.length > 0) {
        // Dekodujemy payload RAZ do zmiennej
        const decoded = DecodeToken(token);


        sessionStorage.setItem("id", decoded.id);
        sessionStorage.setItem("token", token);

        techContext.setSelectedProcesor(decoded.procesor_domyslny);
        contextApp.setSelectedKlient(0);
        contextApp.setSelectedUser(0);

        if (String(hash).trim() !== String(ver?.ver).trim()) {
          contextApp.setRestart(true);
        }

        updateAuthStatus(true, token);
        navigate("/Panel");
      } else {
        console.error("Błąd logowania: nieprawidłowy token");
        setLogowanie(true);
      }
    } catch (error) {
      console.error("Błąd podczas połączenia z serwerem:", error);
      setLogowanie(true);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.center}>
        <Center
          logowanie={logowanie}
          input={input}
          setInput={setInput}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
}

function Center({ input, setInput, handleSubmit, logowanie }) {
  const currentHash = getCurrentBuildHash();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className={style.loginPaine}>
      <form onSubmit={handleSubmit} className={style.form}>
        {logowanie ? (
          <>
            <div>
              <img className={style.icon2} src={iconLogo} alt="logo" />
            </div>
            <div>
              <input
                type="text"
                name="login"
                placeholder="Login"
                value={input.login}
                onChange={handleChange}
                className={style.loginInput}
              />
            </div>

            <div>
              <input
                type="password"
                name="haslo"
                placeholder="Hasło"
                value={input.haslo}
                onChange={handleChange}
                className={style.loginInput}
              />
            </div>

            <button
              type="submit"
              title={`Wersja: ${currentHash}`}
              className={style.myButton}
            >
              Zaloguj
            </button>
          </>
        ) : (
          <div>
            <img className={style.icon} src={iconAdd} alt="Ładowanie..." />
          </div>
        )}
      </form>
    </div>
  );
}